<div class="flex h-full w-full gap-4 p-4">

  <!-- Left side: List of audit records -->
  <div class="w-2/5 h-full flex flex-col">
    <p-panel class="h-full">
      <ng-template pTemplate="header">
        <div class="sticky top-0 z-10 p-4">
          Audit Records
        </div>
      </ng-template>
      <div class="overflow-auto h-full">
        <ul class="divide-y divide-gray-200">
          <li *ngFor="let record of auditRecords()" (click)="selectRecord(record)" 
              class="p-2 cursor-pointer"
              [ngClass]="{'bg-blue-100 border-l-4 border-blue-500': selectedRecord()?.id === record?.id}"
          >
            <div class="flex justify-between items-center font-medium">
              <span>{{ record.action }}</span>
              <span>ID: {{ record.id }}</span>
            </div>
            <div class="text-sm text-[#9d9d9d]">{{ record.dateTime | date: 'yyyy-MM-dd HH:mm:ss.SSS' }}</div>
            <div class="text-xs text-[#9d9d9d]">{{ record.user }}</div>
          </li>
        </ul>
      </div>
    </p-panel>
  </div>

  <!-- Right column: details -->
 <div class="w-3/5 flex flex-col h-full">

  <div class="p-4 border-b">
    <h2 class="text-lg font-semibold">
      Audit Record Details {{ selectedRecord()?.dateTime | date: 'yyyy-MM-dd HH:mm:ss.SSS' }}
    </h2>
     @if (selectedRecord()?.data) {
       <p-button
          size="small"
          severity="success"
          label="Download JSON"
          (click)="downloadDataJson()"
        >
        </p-button>
     }
  </div>

  @if (selectedRecord()) {
    <div class="flex-1 overflow-auto p-4 space-y-4">

      @if (selectedRecord()?.additionalInfo) {
        <div>
          <span class="font-medium block mb-1">Additional Info:</span>
          <div class="!select-text !select-all p-3 text-sm outline overflow-auto whitespace-pre-wrap">
            {{ additionalInfoJson() }}
          </div>
        </div>
      }

      <div class="flex flex-col">
        <span class="font-medium block mb-1">Data:</span>
        <div class="!select-text !select-all p-3 text-sm outline overflow-auto whitespace-pre-wrap">
          {{ dataJson() }}
        </div>
      </div>

    </div>
  } @else {
    <div class="flex items-center justify-center h-full text-gray-500 italic">
      Please select an audit record from the left.
    </div>
  }

</div>

</div>